import { Menu, MenuItem, Popover, Tag } from "@blueprintjs/core";
import styled from "styled-components";
import { AdminToaster } from "../AdminToaster";

function DisplayItem({ value }: { value: string }) {
  return (
    <MenuItem icon="eye-open" text="Show ID">
      <MenuItem text={<RawIdContainer>{value}</RawIdContainer>} />
    </MenuItem>
  );
}

function CopyItem({ value }: { value: string }) {
  return (
    <MenuItem
      icon="clipboard"
      text="Copy"
      onClick={async () => {
        navigator.clipboard.writeText(value);
        AdminToaster.then((t) =>
          t.show({
            message: "Copied to clipboard!",
            intent: "success",
            icon: "tick",
          }),
        );
      }}
    />
  );
}

const RawIdContainer = styled(Tag).attrs({ minimal: true, interactive: true })`
  cursor: pointer;
  font-family: monospace;
  white-space: nowrap;
  font-size: 14px;
  line-height: 14px;
`;

export interface RawIdProps {
  value: string;
  preview: string;
  interactable?: boolean;
}

export function RawId({ value, preview, interactable = true }: RawIdProps) {
  if (!value) return null;
  const content = <RawIdContainer>{preview}</RawIdContainer>;
  if (!interactable) return content;
  return (
    <Popover
      content={
        <Menu>
          <DisplayItem value={value} />
          <CopyItem value={value} />
        </Menu>
      }
    >
      {content}
    </Popover>
  );
}
